import React, { useContext } from "react";
import { FooterHelp, Button, Caption, TextStyle, Link } from "@shopify/polaris";
import { PublicContext } from "lib/context";
import { baseHelper, storageHelper } from "lib/helpers";
import config from "configuration";

const Footer = () => {
  const { history, cms } = useContext(PublicContext);
  const url = baseHelper.parseUrl(config.rootURL);
  const isCustomDomain = window.location.hostname !== url.hostname;
  const footerContent = cms("footer").map((item) => {
    if (item && item.link) {
      const redirectUri = isCustomDomain ? "/register/role" : item.link;
      return (
        <Button key={item.content} plain id="registerHere" onClick={() => history.push(redirectUri)}>
          {item.content}
        </Button>
      );
    }
    return (
      <React.Fragment key={item.content}>
        {isCustomDomain || storageHelper.get("hideMcDetails") ? "Marketplace Provider ? " : item.content}
      </React.Fragment>
    );
  });
  return (
    <>
      <FooterHelp>{footerContent}</FooterHelp>
      {!storageHelper.get("hidePoweredBy") && (
        <center>
          <Caption>
            <TextStyle variation="subdued">
              {"Powered by "}
              {!(isCustomDomain || storageHelper.get("hideMcDetails")) ? (
                <Link url="https://www.successive.tech" external>
                  Successive Digital
                </Link>
              ) : (
                "Successive Digital"
              )}
            </TextStyle>
          </Caption>
        </center>
      )}
    </>
  );
};

export default Footer;
